import ToolStylus from './ToolStylus';
import Shortcut from '../utils/Shortcut';
import type WhiteboardController from '../controllers/WhiteboardController';

class ToolImage extends ToolStylus {
  static toolName = 'Image or video';
  static shortcut = new Shortcut('I');

  static action({ controller }: { controller: WhiteboardController }) {
    controller.actionSetStylus(controller.stylusImage);
  }
}

export default ToolImage;
